import React from 'react'
import { Cell } from 'react-mdl'
import './style.css'

import Calculator from 'APP/lib/attributes-calculator';

const resistanceCap = 75;
const hellExpansionPenalty = 100;
const hellClassicPenalty = 50;
const scrollOfResistance = 10;

export default class Attributes extends React.Component {

    state = {
        baseAttributes: null,
        extraAttributesArray: [],
        activeWeaponTabId: 0,
        resistanceCap: 75
    }

    constructor(props) {
        super(props);

        var baseAttributes = {
            experience: props.data.attributes.experience,
            gold: props.data.attributes.gold,
            stashed_gold: props.data.attributes.stashed_gold,
            unused_skill_points: props.data.attributes.unused_skill_points,
            unused_stats: props.data.attributes.unused_stats
        };

        var extraAttributesArray = []
        
        extraAttributesArray[0] = {
            strength: 0,
            energy: 0,
            dexterity: 0,
            vitality: 0,
            max_hp: props.data.attributes.max_hp,
            max_mana: props.data.attributes.max_mana,
            max_percent_hp: 0,
            max_percent_mana: 0,
            fire_res: 0,
            cold_res: 0,
            light_res: 0,
            poison_res: 0,
            max_fire_res: 0,
            max_cold_res: 0,
            max_light_res: 0,
            max_poison_res: 0
        };
        
        extraAttributesArray[1] = {
            strength: 0,
            energy: 0,
            dexterity: 0,
            vitality: 0,
            max_hp: props.data.attributes.max_hp,
            max_mana: props.data.attributes.max_mana,
            max_percent_hp: 0,
            max_percent_mana: 0,
            fire_res: 0,
            cold_res: 0,
            light_res: 0,
            poison_res: 0,
            max_fire_res: 0,
            max_cold_res: 0,
            max_light_res: 0,
            max_poison_res: 0
        };

        if (props.data.equipped.length > 0) {
            props.data.equipped.map(function (item) {
                if (item.equipped_id === 4 || item.equipped_id === 5) { // primary hand
                    Calculator.calculateItem(item, extraAttributesArray[0]);
                    if (item.main_set_partial_bonuses !== undefined) {
                        Calculator.calculate(extraAttributesArray[0], item.main_set_partial_bonuses);
                    }
                } else if (item.equipped_id === 11 || item.equipped_id === 12) { // alternative hand
                    Calculator.calculateItem(item, extraAttributesArray[1]);
                    if (item.secondary_set_partial_bonuses !== undefined) {
                        Calculator.calculate(extraAttributesArray[1], item.secondary_set_partial_bonuses);
                    }
                } else {
                    Calculator.calculateItem(item, extraAttributesArray[0]);
                    Calculator.calculateItem(item, extraAttributesArray[1]);
                    if (item.main_set_partial_bonuses !== undefined) {
                        Calculator.calculate(extraAttributesArray[0], item.main_set_partial_bonuses);
                    }
                    if (item.secondary_set_partial_bonuses !== undefined) {
                        Calculator.calculate(extraAttributesArray[1], item.secondary_set_partial_bonuses);
                    }
                }
                return true;
            });
        }

        if (props.data.inventory.length > 0) {
            props.data.inventory.map(function(item) {
                // Ok, let's make sure we only count charms those are in charm zone
                if ((item.type === "cm1" || item.type === "cm2" || item.type === "cm3") && item.y > 3 && item.identified === true) {
                    Calculator.calculate(extraAttributesArray[0], item.magic_attributes);
                    Calculator.calculate(extraAttributesArray[1], item.magic_attributes);
                }
                return true;
            });
        }

        if (props.data.set_bonuses.length > 0) {
            for (const [setId, setBonuses] of Object.entries(props.data.set_bonuses[0])) { // eslint-disable-line no-unused-vars
                Calculator.calculate(extraAttributesArray[0], setBonuses);
            }
            for (const [setId, setBonuses] of Object.entries(props.data.set_bonuses[1])) { // eslint-disable-line no-unused-vars
                Calculator.calculate(extraAttributesArray[1], setBonuses);
            }
        }

        // Ok so we got the extra attributes, if vitality or energy is added
        // we'll count it onto the hp and mana attributes.
        if (extraAttributesArray[0].vitality > 0) {
            extraAttributesArray[0].max_hp += Calculator.lifePerVitality[props.data.class]*extraAttributesArray[0].vitality;
        }
        if (extraAttributesArray[1].vitality > 0) {
            extraAttributesArray[1].max_hp += Calculator.lifePerVitality[props.data.class]*extraAttributesArray[1].vitality;
        }

        if (extraAttributesArray[0].energy > 0) {
            extraAttributesArray[0].max_mana += Calculator.manaPerEnergy[props.data.class]*extraAttributesArray[0].energy;
        }
        if (extraAttributesArray[1].energy > 0) {
            extraAttributesArray[1].max_mana += Calculator.manaPerEnergy[props.data.class]*extraAttributesArray[1].energy;
        }
        if (extraAttributesArray[0].max_percent_hp > 0) {
            extraAttributesArray[0].max_hp = Math.floor(extraAttributesArray[0].max_hp * (1 + (extraAttributesArray[0].max_percent_hp/100)));
        }
        if (extraAttributesArray[1].max_percent_hp > 0) {
            extraAttributesArray[1].max_hp = Math.floor(extraAttributesArray[1].max_hp * (1 + (extraAttributesArray[1].max_percent_hp/100)));
        }
        if (extraAttributesArray[0].max_percent_mana > 0) {
            extraAttributesArray[0].max_mana = Math.floor(extraAttributesArray[0].max_mana * (1 + (extraAttributesArray[0].max_percent_mana/100)));
        }
        if (extraAttributesArray[1].max_percent_mana > 0) {
            extraAttributesArray[1].max_mana = Math.floor(extraAttributesArray[1].max_mana * (1 + (extraAttributesArray[1].max_percent_mana/100)));
        }

        // Add base values.
        extraAttributesArray[0].strength += props.data.attributes.strength;
        extraAttributesArray[0].energy += props.data.attributes.energy;
        extraAttributesArray[0].dexterity += props.data.attributes.dexterity;
        extraAttributesArray[0].vitality += props.data.attributes.vitality;
        extraAttributesArray[1].strength += props.data.attributes.strength;
        extraAttributesArray[1].energy += props.data.attributes.energy;
        extraAttributesArray[1].dexterity += props.data.attributes.dexterity;
        extraAttributesArray[1].vitality += props.data.attributes.vitality;

        // Calculate resistances in accordance to Anya quests and difficulty penalties.
        props.data.anya_quests.map(function(q) {
            if(q) {
                extraAttributesArray[0].fire_res += scrollOfResistance;
                extraAttributesArray[0].cold_res += scrollOfResistance;
                extraAttributesArray[0].light_res += scrollOfResistance;
                extraAttributesArray[0].poison_res += scrollOfResistance;
                extraAttributesArray[1].fire_res += scrollOfResistance;
                extraAttributesArray[1].cold_res += scrollOfResistance;
                extraAttributesArray[1].light_res += scrollOfResistance;
                extraAttributesArray[1].poison_res += scrollOfResistance;
            }
            return true;
        });

        extraAttributesArray[0].fire_res += props.data.natural_resistances[0];
        extraAttributesArray[0].cold_res += props.data.natural_resistances[0];
        extraAttributesArray[0].light_res += props.data.natural_resistances[0];
        extraAttributesArray[0].poison_res += props.data.natural_resistances[0];
        extraAttributesArray[1].fire_res += props.data.natural_resistances[1];
        extraAttributesArray[1].cold_res += props.data.natural_resistances[1];
        extraAttributesArray[1].light_res += props.data.natural_resistances[1];
        extraAttributesArray[1].poison_res += props.data.natural_resistances[1];

        // Make sure we reduce the correct amount of resistances for hell.
        var penalty = hellClassicPenalty;
        if (props.data.expansion === true) {
            penalty = hellExpansionPenalty;
        }

        extraAttributesArray[0].fire_res -= penalty;
        extraAttributesArray[0].cold_res -= penalty;
        extraAttributesArray[0].light_res -= penalty;
        extraAttributesArray[0].poison_res -= penalty;
        extraAttributesArray[1].fire_res -= penalty;
        extraAttributesArray[1].cold_res -= penalty;
        extraAttributesArray[1].light_res -= penalty;
        extraAttributesArray[1].poison_res -= penalty;
        
        extraAttributesArray[0].strengthIncreased = extraAttributesArray[0].strength > props.data.attributes.strength;
        extraAttributesArray[0].dexterityIncreased = extraAttributesArray[0].dexterity > props.data.attributes.dexterity;
        extraAttributesArray[0].vitalityIncreased = extraAttributesArray[0].vitality > props.data.attributes.vitality;
        extraAttributesArray[0].energyIncreased = extraAttributesArray[0].energy > props.data.attributes.energy;
        extraAttributesArray[1].strengthIncreased = extraAttributesArray[1].strength > props.data.attributes.strength;
        extraAttributesArray[1].dexterityIncreased = extraAttributesArray[1].dexterity > props.data.attributes.dexterity;
        extraAttributesArray[1].vitalityIncreased = extraAttributesArray[1].vitality > props.data.attributes.vitality;
        extraAttributesArray[1].energyIncreased = extraAttributesArray[1].energy > props.data.attributes.energy;

        this.state = {
            baseAttributes: baseAttributes,
            extraAttributesArray: extraAttributesArray,
            activeWeaponTabId: 0
        };
    }

    handleSwitchWeapons(activeWeaponTabId) {
        this.setState({ activeWeaponTabId: activeWeaponTabId });
    }

    toLocaleString(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    render() {
        let maxHp = this.state.extraAttributesArray[this.state.activeWeaponTabId].max_hp;
        let maxMp = this.state.extraAttributesArray[this.state.activeWeaponTabId].max_mana;
        let fireRes = this.state.extraAttributesArray[this.state.activeWeaponTabId].fire_res;
        let maxFireRes = resistanceCap + this.state.extraAttributesArray[this.state.activeWeaponTabId].max_fire_res;
        let coldRes = this.state.extraAttributesArray[this.state.activeWeaponTabId].cold_res;
        let maxColdRes = resistanceCap + this.state.extraAttributesArray[this.state.activeWeaponTabId].max_cold_res;
        let lightRes = this.state.extraAttributesArray[this.state.activeWeaponTabId].light_res;
        let maxLightRes = resistanceCap + this.state.extraAttributesArray[this.state.activeWeaponTabId].max_light_res;
        let psnRes = this.state.extraAttributesArray[this.state.activeWeaponTabId].poison_res;
        let maxPsnRes = resistanceCap + this.state.extraAttributesArray[this.state.activeWeaponTabId].max_poison_res;
        let strengthIncreased = this.state.extraAttributesArray[this.state.activeWeaponTabId].strengthIncreased;
        let strength = this.state.extraAttributesArray[this.state.activeWeaponTabId].strength;
        let dexterityIncreased = this.state.extraAttributesArray[this.state.activeWeaponTabId].dexterityIncreased;
        let dexterity = this.state.extraAttributesArray[this.state.activeWeaponTabId].dexterity;
        let vitalityIncreased = this.state.extraAttributesArray[this.state.activeWeaponTabId].vitalityIncreased;
        let vitality = this.state.extraAttributesArray[this.state.activeWeaponTabId].vitality;
        let energyIncreased = this.state.extraAttributesArray[this.state.activeWeaponTabId].energyIncreased;
        let energy = this.state.extraAttributesArray[this.state.activeWeaponTabId].energy;

        return (
            <Cell className="attributes" col={4} tablet={12} phone={12}>
                <h3 className="underlined">Attributes</h3>
                <ul className="resources globes">
                    <li>
                        <div className="health globe"><span>{maxHp}</span></div>
                        <span className="resource-label">Life</span>
                    </li>
                    <li>
                        <div className="mana globe"><span>{maxMp}</span></div>
                        <span className="resource-label">Mana</span>
                    </li>
                </ul>
                <h4 className="underlined">Hell resistances</h4>
                <ul className="attribute-list">
                    <li>
                        <span className="attribute-label">Fire Resistance</span>
                        <span className="attribute-value">
                            <small className="fire-res">{fireRes}</small><small>/{maxFireRes}</small>
                        </span>
                    </li>
                    <li>
                        <span className="attribute-label">Cold Resistance</span>
                        <span className="attribute-value">
                            <small className="cold-res">{coldRes}</small><small>/{maxColdRes}</small>
                        </span>
                    </li>
                    <li>
                        <span className="attribute-label">Lightning Resistance</span>
                        <span className="attribute-value">
                            <small className="light-res">{lightRes}</small><small>/{maxLightRes}</small>
                        </span>
                    </li>
                    <li>
                        <span className="attribute-label">Poison Resistance</span>
                        <span className="attribute-value">
                            <small className="poison-res">{psnRes}</small><small>/{maxPsnRes}</small>
                        </span>
                    </li>
                </ul>
                <h4 className="underlined">Core attributes</h4>
                <ul className="attribute-list">
                    <li><span className="attribute-label">Strength</span><span className={`attribute-value increased-${strengthIncreased}`}>{strength}</span></li>
                    <li><span className="attribute-label">Dexterity</span><span className={`attribute-value increased-${dexterityIncreased}`}>{dexterity}</span></li>
                    <li><span className="attribute-label">Vitality</span><span className={`attribute-value increased-${vitalityIncreased}`}>{vitality}</span></li>
                    <li><span className="attribute-label">Energy</span><span className={`attribute-value increased-${energyIncreased}`}>{energy}</span></li>
                </ul>
                <h4 className="underlined">Other</h4>
                <ul className="attribute-list">
                    <li><span className="attribute-label">Experience</span><span className="attribute-value">{this.toLocaleString(this.state.baseAttributes.experience)}</span></li>
                    <li><span className="attribute-label">Gold</span><span className="attribute-value">{this.toLocaleString(this.state.baseAttributes.gold)}</span></li>
                    <li><span className="attribute-label">Stashed gold</span><span className="attribute-value">{this.toLocaleString(this.state.baseAttributes.stashed_gold)}</span></li>
                    <li><span className="attribute-label">Unused skill points</span><span className="attribute-value">{this.state.baseAttributes.unused_skill_points}</span></li>
                    <li><span className="attribute-label">Unused attributes</span><span className="attribute-value">{this.state.baseAttributes.unused_stats}</span></li>
                </ul>
            </Cell>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/character/attributes/index.js